module.exports = __webpack_public_path__ + "img/Categories_bg_07.e27258c4.jpg";